import axios from 'axios';

const generateReport = (idComprador, data) => axios.post(`compradores/${idComprador}/relatorios/geracao`, data);

export default {
  generateReport,
};
